export default {
  message: {
    "strid1": "Login",
    "strid2": "Announcement",
    "strid3": "More",
    "strid4": "Penalty inquiry",
    "strid5": "Report inquery",
    "strid6": "Penalty announcement",
    "strid7": "Security Science",
    "strid8": "Penalty rules",
    "strid9": "Report time",
    "strid10": "Report player",
    "strid11": "Report reason",
    "strid12": "Report result",
    "strid13": "Accepted",
    "strid14": "Violation",
    "strid15": "Penalty time",
    "strid16": "Penalty reason",
    "strid17": "Unbanning time",
    "strid18": "Appeal",
    "strid19": "Appealed",
    "strid20": "Verifying",
    "strid21": "Appeal failed",
    "strid22": "Appeal result",
    "strid23": "Appeal successful",
    "strid24": "prompt",
    "strid25": "Appeal form",
    "strid26": "Possible reasons for punishment",
    "strid27": "Video/picture/plug-in software download address",
    "strid28": "Description",
    "strid29": "self-service system",
    "strid30": "Nicknames",
    "strid31": "AccountID",
    "strid32": "Level",
    "strid33": "Rank",
    "strid34": "Duration Of Game",
    "strid35": "Phone model",
    "strid36": "Mailbox",
    "strid37": "Binding AccountID（google，fb or vk）",
    "strid38": "Before appealing, you need to fill in your account information and contact information so that we can contact you",
    "strid39": "My account was stolen.",
    "strid40": "I didn't cheat, my account was only used by me.",
    "strid41": "I admit that I cheated and I won't do it again.",
    "strid42": "Please enter ",
    "strid43": "Contact Customer Service",
    "strid44": 'I know',
    "strid45": 'No',
    "strid46": 'Please complete the form',
  }
}
